// extracted by mini-css-extract-plugin
export var scrollArea = "_op-0";